import { React } from 'react';
import { useQuery } from '@apollo/client';

import { Loading } from 'app/src/elements/DataState';
import { Outlet, useParams } from 'app/src/utils/routing';

import { CLIENT} from './queries';

const ClientContainer = () => {
  const { clientId: id } = useParams();

  const { data } = useQuery(CLIENT, { variables: { id } });

  if (!data) { return <Loading />; }

  return (
    <Outlet context={{ client: data.client }} />
  );
};

export default ClientContainer;
